import { render, staticRenderFns } from "./CoTwoLocationForm.vue?vue&type=template&id=4499cf8a&scoped=true&"
import script from "./CoTwoLocationForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoLocationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4499cf8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4499cf8a')) {
      api.createRecord('4499cf8a', component.options)
    } else {
      api.reload('4499cf8a', component.options)
    }
    module.hot.accept("./CoTwoLocationForm.vue?vue&type=template&id=4499cf8a&scoped=true&", function () {
      api.rerender('4499cf8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoLocationForm.vue"
export default component.exports